import React, { useState, useEffect } from "react";
import { useUpdateTV } from "../hooks/useTVQueries"; // useUpdateTV hook import

// 🎯 수정된 SettingsManagement - 설정 저장 기능 추가
const SettingsManagement = ({
  tvId,
  settings,
  onRefresh,
  onSettingsChange, // 🎯 새로운 prop: 설정 변경 콜백
  tvData, // 🎯 전체 TV 데이터 (bgmMappings, contentMappings 등)
}) => {
  const [localSettings, setLocalSettings] = useState({
    transitionDuration: settings?.transitionDuration || 1,
    transitionStyle: settings?.transitionStyle || "fade",
  });

  // 🎯 updateTV mutation hook
  const updateTVMutation = useUpdateTV();

  // settings가 변경될 때 로컬 상태 업데이트
  useEffect(() => {
    setLocalSettings({
      transitionDuration: settings?.transitionDuration || 1,
      transitionStyle: settings?.transitionStyle || "fade",
    });
  }, [settings]);

  // 🎯 백엔드 TransitionType enum에 정확히 맞춘 매핑
  const mapTransitionStyleToType = (style) => {
    const mapping = {
      fade: "FADE",
      slideLeft: "LEFT_SLIDE",
      slideRight: "RIGHT_SLIDE",
      slideUp: "UP_SLIDE",
      slideDown: "DOWN_SLIDE",
      zoomIn: "ZOOM_IN",
      zoomOut: "ZOOM_OUT",
      rotateLeft: "ROTATE_LEFT",
      rotateRight: "ROTATE_RIGHT",
      flipHorizontal: "HORIZONTAL_FLIP",
      flipVertical: "VERTICAL_FLIP",
      blinds: "BLIND",
      cube: "CUBE_ROTATION",
    };
    return mapping[style] || "FADE";
  };

  // 🎯 로컬 상태 변경을 부모 컴포넌트에 알림
  const handleSettingsChange = (key, value) => {
    const updatedSettings = {
      ...localSettings,
      [key]: value,
    };

    setLocalSettings(updatedSettings);

    // 🎯 부모 컴포넌트에 설정 변경 알림 (API 호출 없음)
    if (onSettingsChange && typeof onSettingsChange === "function") {
      onSettingsChange(updatedSettings);
    }
  };

  // 🎯 설정 저장 기능 - updateTv API 호출
  const handleSaveSettings = async () => {
    if (!tvId || !tvData) {
      alert("TV ID 또는 TV 데이터가 없습니다.");
      return;
    }

    try {
      // TvUpdateRequest 형식에 맞게 데이터 구성
      const updateData = {
        pin: tvData.pin || null, // PIN 번호 (선택사항)
        isBgmEnabled: tvData.isBgmEnabled || false, // 배경음악 사용여부
        transitionType: mapTransitionStyleToType(localSettings.transitionStyle), // 전환효과 타입
        transitionDuration: Math.round(localSettings.transitionDuration), // 전환시간 (정수로 변환)
        bgmMappings: tvData.bgmMappings || [], // 배경음악 매핑 정보
        contentMappings: tvData.contentMappings || [], // 컨텐츠 매핑 정보
      };

      // console.log("설정 저장 요청 데이터:", updateData);

      // updateTV mutation 실행
      await updateTVMutation.mutateAsync({
        tvId: tvId,
        tvData: updateData,
      });

      alert("설정이 성공적으로 저장되었습니다!");

      // 필요시 데이터 새로고침
      if (onRefresh && typeof onRefresh === "function") {
        onRefresh();
      }
    } catch (error) {
      // console.error("설정 저장 실패:", error);
      alert(`설정 저장에 실패했습니다: ${error.message}`);
    }
  };

  const handlePreviewTransition = () => {
    // 전환 효과 미리보기 (추후 구현)
    alert(
      `전환 효과 미리보기\n스타일: ${localSettings.transitionStyle}\n시간: ${localSettings.transitionDuration}초`
    );
  };

  const handleClearData = async () => {
    if (
      !window.confirm(
        "정말로 이 현황판의 모든 데이터를 초기화하시겠습니까?\n이 작업은 되돌릴 수 없습니다."
      )
    ) {
      return;
    }

    try {
      // 데이터 초기화 API 호출 (추후 구현)
      alert("데이터 초기화 기능은 추후 구현 예정입니다.");
    } catch (error) {
      alert(`데이터 초기화 실패: ${error.message}`);
    }
  };

  // 🎯 백엔드 TransitionType enum에 정확히 맞춘 전환 효과 옵션들
  const transitionOptions = [
    { value: "fade", label: "🌟 페이드 (기본)" },
    { value: "slideLeft", label: "← 좌측 슬라이드" },
    { value: "slideRight", label: "→ 우측 슬라이드" },
    { value: "slideUp", label: "↑ 상단 슬라이드" },
    { value: "slideDown", label: "↓ 하단 슬라이드" },
    { value: "zoomIn", label: "🔍 확대" },
    { value: "zoomOut", label: "🔍 축소" },
    { value: "rotateLeft", label: "↻ 좌회전" },
    { value: "rotateRight", label: "↺ 우회전" },
    { value: "flipHorizontal", label: "↔️ 수평 뒤집기" },
    { value: "flipVertical", label: "↕️ 수직 뒤집기" },
    { value: "blinds", label: "🎭 블라인드" },
    { value: "cube", label: "📦 큐브 회전" },
  ];

  return (
    <div
      style={{
        background: "#f8f9fa",
        border: "2px dashed #dee2e6",
        borderRadius: "12px",
        padding: "20px",
        marginBottom: "20px",
      }}
    >
      {/* 섹션 헤더 */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "20px",
          paddingBottom: "10px",
          borderBottom: "1px solid #dee2e6",
        }}
      >
        <span style={{ fontSize: "20px" }}>⚙️</span>
        <h3
          style={{
            margin: 0,
            fontSize: "18px",
            fontWeight: "600",
            color: "#2d3436",
          }}
        >
          설정 및 관리
        </h3>
      </div>

      {/* 전환 효과 설정 */}
      <div
        style={{
          background: "white",
          borderRadius: "8px",
          padding: "16px",
          marginBottom: "15px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <h4
          style={{
            margin: "0 0 15px 0",
            fontSize: "16px",
            fontWeight: "600",
            color: "#2d3436",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span>🎬</span>
          전환 효과 설정
        </h4>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 200px",
            gap: "20px",
            alignItems: "center",
            marginBottom: "15px",
          }}
        >
          <div>
            <label
              style={{
                display: "block",
                marginBottom: "5px",
                fontWeight: "bold",
                color: "#2d3436",
              }}
            >
              전환 효과 스타일
            </label>
            <select
              value={localSettings.transitionStyle}
              onChange={(e) =>
                handleSettingsChange("transitionStyle", e.target.value)
              }
              style={{
                width: "100%",
                padding: "10px",
                border: "2px solid #ddd",
                borderRadius: "6px",
                fontSize: "14px",
              }}
            >
              {transitionOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label
              style={{
                display: "block",
                marginBottom: "5px",
                fontWeight: "bold",
                color: "#2d3436",
              }}
            >
              전환 효과 시간 (초)
            </label>
            <input
              type="number"
              value={localSettings.transitionDuration}
              onChange={(e) =>
                handleSettingsChange(
                  "transitionDuration",
                  parseFloat(e.target.value)
                )
              }
              min="0.5"
              max="5"
              step="0.5"
              style={{
                width: "100%",
                padding: "10px",
                border: "2px solid #ddd",
                borderRadius: "6px",
                fontSize: "14px",
              }}
            />
          </div>
        </div>

        {/* 🎯 전환 효과 설명 추가 */}
        {/* <div
          style={{
            background: "#f8f9fa",
            border: "1px solid #dee2e6",
            borderRadius: "6px",
            padding: "12px",
            fontSize: "13px",
            color: "#495057",
          }}
        >
          <div style={{ marginBottom: "8px", fontWeight: "600" }}>
            💡 전환 효과 안내
          </div>
          <div style={{ lineHeight: "1.5" }}>
            <div>
              <strong>현재 선택:</strong>{" "}
              {
                transitionOptions.find(
                  (opt) => opt.value === localSettings.transitionStyle
                )?.label
              }
            </div>
            <div>
              <strong>전환 시간:</strong> {localSettings.transitionDuration}초
            </div>
            <div style={{ marginTop: "8px", fontSize: "12px", opacity: "0.8" }}>
              • 전환 효과는 컨텐츠가 바뀔 때 적용됩니다
              <br />• 전환 시간이 길수록 부드럽지만 전체 재생 시간에 영향을
              줍니다
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default SettingsManagement;
